<template>
  <v-app>
    <!--INDICA LA PÁGINA EN LA QUE SE ENCUETRA-->
    <v-card class="grlCardInfo">
      <v-breadcrumbs :items="obtRuta" class="grlClase">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item @click="insertarRuta(item.ruta)" :disabled="item.disabled">
            {{ item.text.toUpperCase() }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </v-card>
    <!--IMAGEN Y TITULO DE LA PÁGINA-->
    <v-card>
      <v-img :src="imgTitle" class="grlCardImg">
        <div class="grlCardInfo">
          <h1 class="my-auto hidden-sm-and-down">Contáctanos</h1>
        </div>
      </v-img>
    </v-card>
    <!---->
    <div class="gralMargenes" id="gralEspaciado">
      <hr />
      <div class="contContacto">
        <div id="contFrame">
          <v-img  :src="imgMapa"></v-img>
        </div>
        <div id="contForm" class="mx-auto">
          <v-form v-model="valid" ref="form" @submit.prevent="enviar" id="form" lazy-validation>
            <v-text-field
              name="nombre"
              label="Nombre:"
              v-model="nombre"
              outlined
              multi-line
              required
              :rules="reglasNombre"
            ></v-text-field>
            <v-text-field
              name="correo"
              label="Correo:"
              v-model="correo"
              outlined
              multi-line
              required
              :rules="reglasCorreo"
            ></v-text-field>
            <v-text-field
              name="numberValue"
              label="Teléfono:"
              v-model="numberValue"
              outlined
              multi-line
              type="number"
              required
              :rules="reglasTelefono"
            ></v-text-field>
            <v-select
              name="areaInteres"
              :items="ofertaEducativa"
              label="Área de interés:"
              v-model="areaInteres"
              outlined
              weight="300px"
              required
              :rules="reglasAreaInteres"
            ></v-select>
            <v-textarea
              name="descripcion"
              label="Descripción:"
              v-model="descripcion"
              outlined
              multi-line
              required
              :rules="reglasDescripcion"
            ></v-textarea>
            <v-btn
              color="black"
              class="white--text"
              >
              <input type="submit" value="SOLICITAR INFORMACIÓN">
              </v-btn>
          </v-form>
        </div>
      </div>
    </div>
  </v-app>
</template>
<script>
// import axios from 'axios';
const emailjs = require('emailjs-com');

export default {
  data: () => ({
    imgMapa: require('../../assets/img/mapa.jpg'),
    valid: true,
    nombre: '',
    correo: '',
    numberValue: null,
    areaInteres: '',
    descripcion: '',
    ofertaEducativa: ['Licenciaturas', 'Posgrados', 'Quejas y Sugerencias'],
    reglasNombre: [
      v => !!v || 'El nombre es requerido',
    ],
    reglasCorreo: [
      v => !!v || 'El correo es requerido',
    ],
    reglasTelefono: [
      v => !!v || 'Se requiere número telefonico',
    ],
    reglasDescripcion: [
      v => !!v || 'Agregue una descripción',
    ],
    reglasAreaInteres: [
      v => !!v || 'El área de interés es requerido',
    ],
    imgTitle: require('../../assets/img/banner-OE.jpg'),
    obtRuta: [
      {
        text: 'Inicio',
        disabled: false,
        ruta: '/',
      },
      {
        text: 'Contacto',
        disabled: true,
        ruta: '/',
      },
    ],
  }),
  methods: {
    enviar(e) {
      (function() {
        emailjs.init('kOntKBwTSBO7hYKfZ');
      });

      e.preventDefault();
      const serviceID = 'default_service';
      const templateID = 'template_78hknza';
      let data = {
        areaInteres: this.areaInteres,
        nombre: this.nombre,
        correo: this.correo,
        numberValue: this.numberValue,
        descripcion: this.descripcion
      };

      if (this.$refs.form.validate()) {
      try {
        emailjs.sendForm(serviceID, templateID, e.target, 'kOntKBwTSBO7hYKfZ', {
        areaInteres: this.areaInteres,
        nombre: this.nombre,
        correo: this.correo,
        numberValue: this.numberValue,
        descripcion: this.descripcion
        })
        alert("ENVIADO CORRECTAMENTE");
        this.$refs.form.reset();
      } catch(e){
          alert("No SE ENVIO EL CORREO");
        }
      }
    },
  },
};
</script>
